import styled, { css } from 'styled-components';
import { colors } from '@/globalStyles';

const button = css`
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 4px;
  border: solid 1px ${props => (props.$variant === 'primary' ? colors.primary : colors.white)};
  background-color: ${props => (props.$variant === 'primary' ? colors.white : colors.primary)};
  color: ${props => (props.$variant === 'primary' ? colors.primary : colors.white)};
  font-size: 18px;
  font-family: 'IBMPlexSans';
  font-weight: 700;
  cursor: pointer;
  padding: 0;

  &:hover {
    color: ${props => (props.$variant === 'primary' ? colors.primaryHover : colors.white)};
    box-shadow: 0 3px 15px 0 rgba(0, 0, 0, 0.35);
  }

  &:disabled {
    box-shadow: none;
    opacity: 0.5;
    cursor: default;
    pointer-events: none;
  }

  &:focus-visible {
    outline: none;
  }
`;

export const ButtonStyled = styled.button`
  ${button};
`;
// tag button replaced with div, because there's incorrect behavior when we click inside cotextmenu of the tooltip (it's closing without a response)
export const ButtonDivStyled = styled.div`
  ${button};
  padding: 0px 20px;
`;
